import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-274e2dd0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "card" }
const _hoisted_2 = { id: "img-container" }
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = { id: "info-container" }
const _hoisted_5 = { id: "date" }
const _hoisted_6 = { id: "author-container" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "author-img" }, null, -1))
const _hoisted_8 = { id: "info" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { id: "redacted-by" }, "Redactado por:", -1))
const _hoisted_10 = { id: "author" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        id: "card-img",
        src: _ctx.article.img,
        alt: _ctx.article.title
      }, null, 8, _hoisted_3)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("h6", _hoisted_5, _toDisplayString(_ctx.article.date), 1),
      _createElementVNode("h1", null, _toDisplayString(_ctx.article.title), 1),
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _createElementVNode("h6", _hoisted_10, _toDisplayString(_ctx.article.author), 1)
        ])
      ]),
      _createElementVNode("p", null, _toDisplayString(_ctx.article.abstract), 1)
    ])
  ]))
}